// 🔧 use_is_event_manager.js
// ✅ Purpose: Determine if the current user is a manager for a specific event
// ✅ Features:
// - Checks if user.uid matches event.ownerId or is included in event.managerIds
// - Returns `true`, `false`, or `null` (while loading)

import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";

import { logger } from '../utils/logger';

export const useIsEventManager = (eventId) => {
    const [user] = useAuthState(auth);
    const [isManager, setIsManager] = useState(null); // null = loading
  
    useEffect(() => {
      const check = async () => {
        if (!user || !eventId) {
          logger.log("🚫 Missing user or eventId", {});
          return;
        }
  
        try {
  
          const eventRef = doc(db, "events", eventId);
          const eventUserRef = doc(db, "events", eventId, "users", user.uid);
          const [eventSnap, eventUserSnap] = await Promise.all([
            getDoc(eventRef),
            getDoc(eventUserRef),
          ]);
          if (!eventSnap.exists()) {
            logger.log("📭 No such event", {});
            setIsManager(false);
            return;
          }
  
          const data = eventSnap.data();
          const eventUserData = eventUserSnap.exists()
            ? eventUserSnap.data()
            : {};
          const explicitlyPending = eventUserData.pendingManager === true;
          const match =
            !explicitlyPending &&
            (
              data.ownerId === user.uid ||
              (Array.isArray(data.managerIds) && data.managerIds.includes(user.uid)) ||
              ["admin", "manager"].includes(eventUserData.role)
            );
    
          setIsManager(match);
        } catch (err) {
          logger.error("❌ Failed to check event manager status:", {
            value: err
          });
          setIsManager(false);
        }
      };
  
      check();
    }, [eventId, user]);
  
    return isManager; // true, false, or null (while loading)
  };
